import Header from './components/Header';
import Hero from './components/Hero';
import AboutSection from './components/AboutSection';
import CardsSection from './components/CardsSection';
import RankingSection from './components/RankingSection';
import MediaSection from './components/MediaSection';
import AppSection from './components/AppSection';
import IndexSection from './components/IndexSection';
import TopicsSection from './components/TopicsSection';
import ContactSection from './components/ContactSection';
import UpdatesSection from './components/UpdatesSection';
import FAQSection from './components/FAQSection';
import FeaturesSection from './components/FeaturesSection';
import CommentsSection from './components/CommentsSection';
import CarouselSection from './components/CarouselSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <AboutSection />
        <CardsSection />
        <RankingSection />
        <MediaSection />
        <AppSection />
        <IndexSection />
        <TopicsSection />
        <ContactSection />
        <UpdatesSection />
        <FAQSection />
        <FeaturesSection />
        <CommentsSection />
        <CarouselSection />
      </main>
      <Footer />
    </>
  );
}